"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LEVELS = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _reactInputMask = _interopRequireDefault(require("react-input-mask"));
var _uuid = require("uuid");
var _reactI18next = require("react-i18next");
var _hidePwDefault = _interopRequireDefault(require("@teladoc/pulse/icons/hide-pw-default.svg"));
var _showPwDefault = _interopRequireDefault(require("@teladoc/pulse/icons/show-pw-default.svg"));
var _lockDefault = _interopRequireDefault(require("@teladoc/pulse/icons/lock-default.svg"));
var _PasswordCriteria = _interopRequireDefault(require("../PasswordCriteria"));
var _PasswordStrength = _interopRequireDefault(require("../PasswordStrength"));
var _useValidation = _interopRequireDefault(require("../Form/use-validation"));
var _useLabelValidation = _interopRequireDefault(require("../Form/use-label-validation"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _TextInput = require("../TextInput");
var _TextInputModule = _interopRequireDefault(require("../TextInput/TextInput.module.scss"));
var _PasswordInputModule = _interopRequireDefault(require("./PasswordInput.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["classNameRoot", "classNameControl", "classNameItem", "testAttrRoot", "testAttrControl", "testAttrItem", "testAttrToggle", "testAttrError", "i18nItemLabel", "i18nToggleLabelShow", "name", "id", "label", "placeholder", "required", "readOnly", "focus", "disabled", "error", "customValidationError", "defaultValue", "helpNode", "maxLength", "showToggle", "onChange", "onFocus", "onBlur", "onInvalid", "variant", "firstName", "lastName", "username", "companyName"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const LEVELS = exports.LEVELS = ['very-weak', 'average', 'strong', 'empty'];
const PasswordInput = _ref => {
  let {
      classNameRoot,
      classNameControl,
      classNameItem,
      testAttrRoot,
      testAttrControl,
      testAttrItem,
      testAttrToggle,
      testAttrError,
      i18nItemLabel,
      i18nToggleLabelShow,
      name,
      id,
      label,
      placeholder,
      required,
      readOnly,
      focus,
      disabled,
      error,
      customValidationError,
      defaultValue,
      helpNode,
      maxLength,
      showToggle,
      onChange,
      onFocus,
      onBlur,
      onInvalid,
      variant,
      firstName,
      lastName,
      username,
      companyName
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [key, setKey] = (0, _react.useState)((0, _uuid.v4)());
  const [showPassword, setShowPassword] = (0, _react.useState)(false);
  const [value, setValue] = (0, _react.useState)(defaultValue || '');
  const [passwordLevel, setPasswordLevel] = (0, _react.useState)('empty');
  const {
    ref,
    errorId,
    isValid,
    errorElement,
    showInvalid,
    setValidationState
  } = (0, _useValidation.default)({
    id,
    disabled,
    error,
    customValidationError,
    onInvalid
  });
  const onChangeCallback = evt => {
    setValidationState(null);
    setValue(evt.target.value);
    if (onChange) {
      onChange(evt);
    }
  };
  const onShowToggle = () => {
    setKey((0, _uuid.v4)());
    setShowPassword(show => !show);
  };
  const describedBy = [];
  if (helpNode) {
    describedBy.push("".concat(id, "-help"));
  }
  if (showInvalid) {
    describedBy.push(errorId);
  }
  (0, _useLabelValidation.default)(label, i18nItemLabel, rest);
  (0, _react.useEffect)(() => {
    if (focus) {
      const {
        current: field
      } = ref;
      const fieldLength = field.value.length;
      field.focus();
      field.setSelectionRange(fieldLength, fieldLength);
    }
  }, [focus, ref]);
  (0, _react.useEffect)(() => {
    setValidationState(null);
  }, [disabled, setValidationState]);
  const handleUpdate = _ref2 => {
    let {
      isFulfilled
    } = _ref2;
    if (!value) {
      setPasswordLevel('empty');
      return;
    }
    if (isFulfilled && value.length >= 11) {
      setPasswordLevel('strong');
    } else if (isFulfilled && value.length >= 8) {
      setPasswordLevel('average');
    } else {
      setPasswordLevel('very-weak');
    }
  };
  const isActive = !disabled && !readOnly;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    className: (0, _cnbuilder.cnb)(_PasswordInputModule.default.root, _TextInputModule.default.root, {
      [_TextInputModule.default.withHelpNode]: Boolean(helpNode)
    }, {
      [_TextInputModule.default.containsError]: !isValid
    }, {
      [_TextInputModule.default.disabled]: disabled
    }, {
      [_TextInputModule.default.readOnly]: readOnly
    }, classNameRoot)
  }, !isValid && {
    'data-invalid-field': true
  }), {}, {
    "data-test": testAttrRoot,
    children: [label && /*#__PURE__*/(0, _react.cloneElement)(label, {
      className: _TextInputModule.default.label,
      htmlFor: id,
      required
    }), helpNode && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _TextInputModule.default.helpNode,
      id: "".concat(id, "-help"),
      children: helpNode
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _cnbuilder.cnb)(_TextInputModule.default.control, classNameControl),
      "data-test": testAttrControl,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _TextInputModule.default.itemContainer,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactInputMask.default, _objectSpread(_objectSpread({
          ref: ref,
          id: id,
          "data-test": testAttrItem,
          className: (0, _cnbuilder.cnb)(_TextInputModule.default.item, {
            [_PasswordInputModule.default.withToggle]: showToggle
          }, classNameItem),
          name: name,
          type: showPassword ? 'text' : 'password',
          placeholder: placeholder,
          disabled: disabled,
          "aria-label": i18nItemLabel,
          required: required,
          readOnly: readOnly,
          "aria-disabled": readOnly,
          maxLength: maxLength,
          onChange: onChangeCallback,
          onFocus: onFocus,
          onBlur: onBlur,
          defaultValue: value
        }, describedBy.length && {
          'aria-describedby': describedBy.join(' ')
        }), {}, {
          "aria-invalid": !isValid
        }, rest), key), showToggle && isActive && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
          testAttr: testAttrToggle,
          className: _PasswordInputModule.default.toggle,
          i18nLabel: i18nToggleLabelShow || "".concat(showPassword ? t('ui:passwordInput.show') : t('ui:passwordInput.hide')),
          "aria-pressed": showPassword ? 'true' : 'false',
          "aria-controls": id,
          disabled: disabled,
          onClick: onShowToggle,
          children: showPassword ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_hidePwDefault.default, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_showPwDefault.default, {})
        }), readOnly && /*#__PURE__*/(0, _jsxRuntime.jsx)(_lockDefault.default, {
          className: (0, _cnbuilder.cnb)(_PasswordInputModule.default.toggle, _PasswordInputModule.default['lock-icon'])
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _PasswordInputModule.default['sr-only'],
          "aria-live": "polite",
          children: showPassword ? t('ui:passwordInput.selected') : t('ui:passwordInput.notSelected')
        })]
      })
    }), showInvalid && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _PasswordInputModule.default['password-input-error'],
      children: /*#__PURE__*/(0, _react.cloneElement)(errorElement, {
        id: errorId,
        testAttr: testAttrError
      })
    }), variant === 'create' && isActive && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _PasswordInputModule.default['strength-indicator'],
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordStrength.default, {
          level: passwordLevel,
          totalSteps: 3,
          currentStep: LEVELS.indexOf(passwordLevel) + 1
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _PasswordInputModule.default['criteria-list-label'],
        role: "alert",
        "aria-atomic": true,
        "aria-live": "polite",
        children: t("ui:passwordStrength.".concat(passwordLevel))
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _cnbuilder.cnb)(_PasswordInputModule.default['criteria-list-container'], _PasswordInputModule.default["level-".concat(passwordLevel)]),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _PasswordInputModule.default['criteria-list-title'],
          children: t('ui:passwordCriteria.mustInclude')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordCriteria.default, {
          value: value,
          onUpdate: handleUpdate,
          firstName: firstName,
          lastName: lastName,
          username: username,
          companyName: companyName
        })]
      })]
    })]
  }));
};
PasswordInput.defaultProps = {
  testAttrToggle: 'password-input-toggle',
  testAttrRoot: 'password-input-root',
  testAttrControl: 'password-input-control',
  testAttrItem: 'password-input-item',
  testAttrError: 'password-input-error',
  showToggle: true,
  maxLength: 64
};
var _default = exports.default = PasswordInput;